export default "__VITE_ASSET__b6dfe55f__"